/**
 * @file 申诉页面
 * @author wangzhuang
 */

import {rcAjax, getAcsToken} from '../util';
import {
    APPEAL_GET_DETAIL,
    // GET_APPEAL_PERSON,
    // GET_APPEAL_COMPANY,
    GET_APPEAL_SEARCH,
    // GET_APPEAL_GOV,
    GET_APPEAL_EDIT,
    APPEAL_UPDATE,
    APPEAL_CLEAN,
    GET_APPEAL_SUBMIT
} from './ActionTypes';

export function fetchAppealSearch(dispatch, params) {
    // type 1email 2phone verity=val
    return rcAjax('POST', '/api/v1/appeal/searchv2', {}, params, data => {
        dispatch({type: GET_APPEAL_SEARCH, data: data.data});
    });
}

export async function appealSubmit(dispatch, params) {
    // 获取接口签名Acs-Token放入请求头
    const token = await getAcsToken();
    return rcAjax('POST', '/api/v1/phone/appeal', {}, params, data => {
        dispatch({type: GET_APPEAL_SUBMIT, data: data.data});
    }, {'Acs-Token': token});
}

export function fetchGetDetail(dispatch, params) {
    return rcAjax('POST', '/api/v1/appeal/getDetail', {}, params, data => {
        dispatch({type: APPEAL_GET_DETAIL, data: data.data});
    });
}

export function fetchGetEdit(dispatch, params) {
    return rcAjax('POST', '/api/v1/appeal/edit', {}, params, data => {
        dispatch({type: GET_APPEAL_EDIT, data: data.data});
    });
}

export function updateAppeal(dispatch, obj) {
    dispatch({
        type: APPEAL_UPDATE,
        data: obj
    });
    return obj;
}
export function cleanAppeal(dispatch) {
    dispatch({
        type: APPEAL_CLEAN
    });
}
